/**
 * angular-admin-oskey-io
 *
 * @license
 * Copyright (c) 2021-2025, OSKEY SAS. All rights reserved.
 *
 * The source code is protected under international copyright law.
 * All rights reserved and protected by the copyright holders.
 *
 * The source code is confidential and only available to authorized individuals with the permission of the copyright holders.
 * If you encounter this source code and do not have permission, please contact the copyright holders and delete this file.
 */

import { OSKSideMenu } from '../types/side-menus.type';

export const OSKUserDefaultSidemenu: OSKSideMenu = {
  name: '',
  items: [
    {
      routerLink: '/account',
      icon: 'person',
      label: 'portals.sidemenu.user.account',
      viewType: 'user'
    },
    // {
    //   label: 'portals.sidemenu.user.organizationDivider',
    //   isDivider: true
    // },
    // {
    //   routerLink: '/organizations/pending',
    //   icon: 'corporate_fare',
    //   label: 'portals.sidemenu.user.organizationRequests'
    // },
    {
      routerLink: '/organizations/invitations',
      icon: 'person_add',
      label: 'portals.sidemenu.user.orgnaizationInvitations',
      viewType: 'user'
    }
  ]
};
